/**
 * Asynchronously loads the component for PowerBIPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
